import styled from "styled-components";

export const Container = styled.section`
	margin: 0 auto;
	width: 80%;
	height: 100%;
	padding: 2rem;
	background: #edeff5;
	box-sizing: border-box;
`;

export const Wrapper = styled.div`
	margin: 1rem 0;
	width: 95%;
	background-color: white;
	padding: 1rem;
`;
